<template>
  <el-dialog
    :title="this.userGroupID === null ? '新增人员组' : '编辑人员组'"
    :visible.sync="dialogFormVisible"
    custom-class="custom_dialog"
    :close-on-click-modal="false"
  >
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form
          :model="userGroupForm"
          :rules="userGroupFormRules"
          ref="userGroupForm"
          label-width="110px"
          class="demo-ruleForm"
          size="mini"
          :label-position="is_xs ? 'top' : 'left'"
        >
          <el-form-item label="人员组名称：" prop="MeetingUserGroupName">
            <el-input
              v-model="userGroupForm.MeetingUserGroupName"
              autocomplete="off"
              placeholder="请输入人员组名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="显示顺序：">
            <el-col :span="16">
              <el-form-item class="el-form-item-internal" prop="Sort">
                <el-input
                  v-model="userGroupForm.Sort"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :max="1000000"
                  autocomplete="off"
                  placeholder="请输入排序序号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveUserGroup('userGroupForm')"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import voteUserApi from '../../api/vote/voteUser'
export default {
  name: 'EditRule',
  data () {
    const validateSort = (rule, value, callback) => {
      if (value >= 1000000) {
        callback(new Error('排序值必须小于7位数！'))
      } else {
        callback()
      }
    }
    return {
      userGroupForm: {
        MeetingUserGroupID: null,
        MeetingID: null,
        MeetingUserGroupName: null,
        Sort: null
      },
      userGroupFormRules: {
        MeetingUserGroupName: [
          { required: true, message: '请输入人员组名称', trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度最多50个字符。', trigger: 'blur' }],
        Sort: [
          { validator: validateSort, trigger: 'blur' }]
      },
      dialogFormVisible: false,
      userGroupID: null
    }
  },
  props: {
    meetId: { type: String },
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    getVoteUserGroup: function () {
      voteUserApi.getVoteUserGroup({
        meetingUserGroupID: this.userGroupID
      }).then(data => {
        this.userGroupForm = data
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    saveUserGroup: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.openLoading('保存中…')
          voteUserApi.editVoteUserGroup(this.userGroupForm).then(data => {
            this.openLoading().close()
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            this.dialogFormVisible = false
            this.fatherSubmitDialog()
          }).catch(err => {
            this.openLoading().close()
            this.dialogFormVisible = false
            this.fatherSubmitDialog()
            return err
          })
        } else {
          return false
        }
      })
    },
    openEditUserGroup: function (userGroupID) {
      this.openLoading()
      this.dialogFormVisible = true
      this.userGroupID = userGroupID
      if (!userGroupID) {
        this.userGroupForm = {}
        this.userGroupForm.MeetingID = this.meetId
        this.openLoading().close()
      } else {
        this.getVoteUserGroup()
      }
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
